import { render, staticRenderFns } from "./form.vue?vue&type=template&id=78fa3c6b&scoped=true&"
import script from "./form.vue?vue&type=script&lang=js&"
export * from "./form.vue?vue&type=script&lang=js&"
import style0 from "./form.vue?vue&type=style&index=0&id=78fa3c6b&lang=less&scoped=true&"
import style1 from "./form.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fa3c6b",
  null
  
)

export default component.exports